<div class="content grid-1-auto md3-surface">
  <div class="content">
    <app-calculation-spreadsheet *ngIf="loaded && cvData?.cvData"
                                 [calcId]="cvData.cvID"
                                 [isMGMT]="excSecurity.isFeatured('RCALCVMGMT')"

                                 [exceljson]="cvData.cvData"
                                 [autoFillObject]="info"

                                 (Save)="calculationSave(false, false, false, $event)"
                                 (exportSheets)="exportSheets($event)"
                                 (downloadSheets)="downloadSheets($event)"

                                 [readOnly]="isReadOnly()"
    >
    </app-calculation-spreadsheet>
  </div>
	<!-- Side Bar -->
	<div class="md3-card-on-surface app-height-auto app-drawer" style="overflow: visible;">
		<i class="disabled search-filter-action"></i>
		<i class="search-filter-seperator"></i>

		<i class="fal fa-save search-filter-action"
		   (click)="calculationSave()"
		   [class.disabled]="!(VCSpreadsheet?.isDirty || isNew)"
		   [tooltip]="getGlobal('Save')"
		   flow="left">
		</i>
		<i class="fal fa-pencil search-filter-action"
		   (click)="openModalCalculationVersion()"
		   [class.disabled]="isNew"
		   [tooltip]="getGlobal('Edit')"
		   flow="left">
		</i>
		<i class="search-filter-seperator"></i>
		<i class="fal fa-download search-filter-action"
       *ngIf="excSecurity.isFeatured('DEVELOPMENT')"
       (click)="download()"
       [class.disabled]="isNew"
       [tooltip]="'Download'"
       flow="left">
    </i>
    <i class="fal fa-file-signature search-filter-action"
       *ngIf="showSignatureButton"
       (click)="doSignature()"
       [class.disabled]="isNew"
       [tooltip]="'Unterschrift'"
       flow="left">
    </i>
	</div>
</div>
